<template>
  <div class="noteMsg" style="padding: 3vw; font-size: 3.5vw">
    <span v-html="html"></span>
  </div>
</template>

<script>
import {closeLoading, DO_NET_URL, loading, toask} from "@/config/config";
import axios from "axios";
import router from "@/router";

export default {
name: "NewMsg",
  data(){
    return{
      id:"",
      html:"loading...",
      key:""
    }
  },
  mounted() {
    this.id=this.$route.query.id
    this.key=this.$route.query.key
    this.selectNewMsg()
  },
  methods:{
    selectNewMsg(){
      let that=this
      axios.get(DO_NET_URL+"News/GetNewById?id="+this.id, {
        headers: {
          token: localStorage.getItem("iwa_token"),
          'Content-Type': "application/x-www-form-urlencoded",
          'timestamp': new Date().getTime(),
          'accreditToken': that.key,
          'flutterSDK': "???flutter==",
        }
      }).then(response => {
        console.log(response.data.data)
        that.html=response.data.data.newNote.replace(/<img/g,"<img style='width:100%'")
      }).catch(error => {
        // 处理错误情况
        console.error(error);
        that.html=error
        toask(error,6)
      });
    },
  }
}
</script>

<style scoped>
  img{
    width: 100%;
  }
  .noteMsg img{
    min-width: 100%;
    width: 100%;
  }
</style>